import classNames from "classnames";
import Link from "next/link";
import React from "react";
import { useSelector } from "react-redux";
import { UserState } from "../../../../redux/reducers/user.reducer";
import { userSelector } from "../../../../redux/selectors/app.selectors";
import Utils from "../../../../utils/Utils";
import BrandTooltip from "../../BrandTooltip";
import CustomBrandTooltip from "../../CustomBrandTooltip";
import Dropdown, {
  NextJSHeadlessLink,
} from "../../custom-components/menu/Dropdown";
import { DashboardItemsType } from "../UserDashboard";
import { ENV_DINS_NUMBER } from "../../../../constants/secret";

interface UserDashboardMobileViewProps {
  navBarItems: DashboardItemsType[];
  selectedMenu: string;
  collapsed: boolean;
  brandUserDashBoardConfigs: {
    tiers: any;
    tires_value: any;
    suggestion_email: any;
  };
  setIsDisconnectedModalOpen: Function;
  setIsSupportModalOpen: Function;
  isUser: boolean;
  setModalType: Function;
}

const UserDashboardMobileView: React.FC<UserDashboardMobileViewProps> = ({
  navBarItems,
  selectedMenu,
  setIsDisconnectedModalOpen,
}) => {
  const { adminData, userData }: UserState = useSelector(userSelector);
  const filteredItems = [...navBarItems].filter((i) => !i.isHidden);

  const order = ["home", "exclusive_content", "achievements", "more"];
  const shuffledItems =
    filteredItems.filter((e) => order.includes(e.value)).length > 2
      ? filteredItems
        .filter((item) => order.includes(item.value))
        .sort((a, b) => order.indexOf(a.value) - order.indexOf(b.value))
      : filteredItems;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[51] md:hidden sm:h-[6rem] rounded-t-[2rem] bg-dashboard shadow-lg shadow-black/70">
      {/* Navbar Items */}
      <div
        id="mobile_menu"
        className="flex items-center no-tap-highlight sm:h-full w-full justify-evenly"
      >
        {shuffledItems.map((item: DashboardItemsType) => {
          const linkOrButtonChild = (
            <BrandTooltip
              className="z-[60] cursor-pointer"
              tooltip={item.label}
              place="top-start"
              id={`${item.value}_mobile_menu_tooltip`}
            >
              <span
                className={`relative sm:p-[20px] p-[10px] sm:p-3 duration-300 rounded-full overflow-hidden ${item.regex?.test(selectedMenu || "")
                  ? "drop-shadow-dashboardSelected gradient-button text-textButton"
                  : ""
                  } `}
                style={{
                  WebkitBackfaceVisibility: "hidden",
                  WebkitTransform: "translateZ(0)",
                }}
              >
                {item.icon}
              </span>
            </BrandTooltip>
          );

          // if Link
          if (item.defaultRoutePath) {
            return (
              <div key={`${item.value}_mobile`}>
                {!item.openInNewTab ? (
                  <Link
                    href={item.defaultRoutePath}
                    legacyBehavior
                    onClick={
                      item.isDisabled
                        ? (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }
                        : undefined
                    }
                  >
                    <a
                      className={`flex space-x-5 items-center  !justify-start p-1 h-16 w-16 ${item.isDisabled ? "opacity-50 cursor-not-allowed" : ""
                        }`}
                      onClick={
                        item.isDisabled
                          ? (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                          }
                          : undefined
                      }
                    >
                      {linkOrButtonChild}
                    </a>
                  </Link>
                ) : (
                  <a
                    href={item.defaultRoutePath}
                    className={`flex space-x-5 items-center w-full  !justify-start p-1 ${item.isDisabled ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    onClick={
                      item.isDisabled
                        ? (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }
                        : undefined
                    }
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {linkOrButtonChild}
                  </a>
                )}
              </div>
            );
          } else if (!item.openDropdown && item.onClick) {
            <button
              onClick={item.onClick}
              className={`flex space-x-5 items-center w-full  !justify-start p-1 ${item.isDisabled ? "opacity-50 cursor-not-allowed" : ""
                }`}
              disabled={item.isDisabled}
            >
              {linkOrButtonChild}
            </button>;
          } else if (
            item.openDropdown &&
            item.dropdownItems &&
            item.dropdownItems?.length > 0
          ) {
            return (
              <div key={`${item.value}_mobile`}>
                <Dropdown
                  menuItemsClassName={`bottom-[6rem] right-0 rounded-[1.25rem] w-44 text-xs lg:text-sm font-medium grid grid-cols-1 shadow-primaryCardShadow`}
                  disabled={item.isDisabled}
                  items={[
                    ...(item.dropdownItems)
                      .filter((i) => !i.isHidden)
                      .map((dropItem) => {
                        const labelChild = (
                          <>
                            <span className={`py-2 font-semibold`}>
                              {dropItem.label}
                            </span>
                          </>
                        );
                        return dropItem.defaultRoutePath ? (
                          // If Link
                          !dropItem.openInNewTab ? (
                            <NextJSHeadlessLink
                              onClick={
                                dropItem.isDisabled
                                  ? (e: any) => {
                                    // If link is disabled
                                    e.preventDefault();
                                    e.stopPropagation();
                                  }
                                  : undefined
                              }
                              href={dropItem.defaultRoutePath}
                              key={dropItem.value}
                              className={classNames(
                                "flex space-x-2 items-center w-full !justify-start px-4 py-2",
                                {
                                  "!cursor-not-allowed !opacity-50 hover:!bg-transparent":
                                    dropItem.isDisabled,
                                }
                              )}
                            >
                              {labelChild}
                            </NextJSHeadlessLink>
                          ) : (
                            <a
                              href={dropItem.defaultRoutePath}
                              key={dropItem.value}
                              target="_blank"
                              rel="noreferrer noopener"
                              onClick={
                                dropItem.isDisabled
                                  ? (e: any) => {
                                    // If link is disabled
                                    e.preventDefault();
                                    e.stopPropagation();
                                  }
                                  : undefined
                              }
                              className={classNames(
                                "flex space-x-2 items-center w-full !justify-start px-4 py-2",
                                {
                                  "!cursor-not-allowed !opacity-50 hover:!bg-transparent":
                                    dropItem.isDisabled,
                                }
                              )}
                            >
                              {labelChild}
                            </a>
                          )
                        ) : (
                          <button
                            disabled={dropItem.isDisabled}
                            onClick={dropItem.onClick}
                            className={classNames(
                              "flex space-x-2 items-center w-full !justify-start px-4 py-2",
                              {
                                "!cursor-not-allowed !opacity-50 hover:!bg-transparent":
                                  dropItem.isDisabled,
                              }
                            )}
                          >
                            {labelChild}
                          </button>
                        );
                      }),
                    ...(userData || adminData
                      ? [
                        <div
                          key={"logout_more_menu_mobile"}
                          className="flex  pb-5 pt-3 px-4 space-y-1 !text-sm cursor-pointer transition-colors duration-300"
                          onClick={() => {
                            setIsDisconnectedModalOpen(true);
                          }}
                        >
                          <div className="flex  ">
                            <span className="whitespace-nowrap opacity-60">
                              Log Out
                            </span>
                          </div>
                          {adminData && (
                            <p
                              key="account_menu"
                              className="px-5 text-xs font-light text-center opacity-50"
                            >
                              [
                              {adminData?.wallet_address
                                ? Utils.getEllipsisedAddress(
                                  adminData?.wallet_address
                                )
                                : Utils.getEllipsisedEmail(adminData?.email!)}
                              ]
                            </p>
                          )}
                        </div>, <div key="dins_number" className=" flex w-full px-4 pb-4 justify-center !text-[10px] opacity-60"> <span className="whitespace-nowrap">{ENV_DINS_NUMBER}</span></div>
                      ]
                      : []),
                  ]}
                >
                  {/* Dropdown Button */}
                  <div
                    key={`${item.value}_mobile`}
                    className={`rounded-none rounded-r-full transition-colors duration-300 `}
                  >
                    <span className="flex space-x-5 items-center !justify-start p-1">
                      <span
                        id={`${item.value}_mobile_menu_tooltip`}
                        className="p-3 rounded-full"
                      >
                        {item.icon}
                      </span>
                    </span>
                  </div>
                </Dropdown>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default React.memo(UserDashboardMobileView);
